<div>
  <div style="margin-bottom: 20px;">
    <h2 style="font-size: 24px; font-weight: 700; color: #1C593D; margin: 0 0 4px 0;">Calcula tu cambio</h2>
    <p style="font-size: 14px; color: #666; margin: 0;">Ingresa el monto a enviar</p>
  </div>

  <!-- Rate Display -->
  <app-fiat-change [ves_buy_rate]="ves_buy_rate" [showBuy]="false"></app-fiat-change>

  <!-- Send CLP -->
  <div style="margin-bottom: 8px; position: relative;">
    <label style="display: block; font-size: 14px; font-weight: 600; color: #1C593D; margin-bottom: 8px;">Tu envias CLP</label>
    <div #sendWrapper style="display: flex; align-items: center; background: white; border: 2px solid #e0e0e0; border-radius: 12px; padding: 12px 16px; transition: border-color 0.2s;">
      <input type="text"
        [(ngModel)]="valorClp"
        (keyup)="transformCurrency('clp')"
        (keypress)="soloNumeros($event)"
        (focus)="sendWrapper.style.borderColor='#1C593D'" (blur)="sendWrapper.style.borderColor='#e0e0e0'"
        placeholder="$0"
        pattern="[0-9]*"
        maxlength="11"
        style="flex: 1; border: none; outline: none; font-size: 26px; font-weight: 700; color: #1a1a1a; background: transparent; width: 100%;" />
      <button *ngIf="valorClp!=''" type="button" (click)="clearValAvailableCLP()"
        style="display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; background: #f5f5f5; border: none; border-radius: 8px; cursor: pointer; margin-right: 8px; flex-shrink: 0;"
        onmouseover="this.style.background='#e0e0e0'" onmouseout="this.style.background='#f5f5f5'">
        <span style="font-size: 16px; color: #666; line-height: 1;">&#10005;</span>
      </button>
      <div style="display: flex; align-items: center; gap: 6px; background: #f5f5f5; padding: 8px 12px; border-radius: 8px; font-size: 14px; font-weight: 600; color: #1e5a3f; flex-shrink: 0;">
        CLP
      </div>
    </div>
  </div>

  <!-- Arrow icon between inputs -->
  <div style="display: flex; justify-content: center; margin: 4px 0;">
    <div style="width: 48px; height: 48px; border-radius: 50%; background: #1C593D; border: 4px solid #f8f9fa; display: flex; align-items: center; justify-content: center;">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M7 10L12 5L17 10M17 14L12 19L7 14" stroke="white" stroke-width="2" />
      </svg>
    </div>
  </div>

  <!-- Receive VES -->
  <div style="margin-bottom: 20px;">
    <label style="display: block; font-size: 14px; font-weight: 600; color: #1C593D; margin-bottom: 8px;">Tu recibes VES</label>
    <div #receiveWrapper style="display: flex; align-items: center; background: white; border: 2px solid #e0e0e0; border-radius: 12px; padding: 12px 16px; transition: border-color 0.2s;">
      <input type="text"
        [(ngModel)]="valorFiat"
        (keyup)="transformCurrency('fiat')"
        (keypress)="soloNumeros($event)"
        (focus)="receiveWrapper.style.borderColor='#1C593D'" (blur)="receiveWrapper.style.borderColor='#e0e0e0'"
        placeholder="$0"
        pattern="[0-9]*"
        maxlength="11"
        style="flex: 1; border: none; outline: none; font-size: 26px; font-weight: 700; color: #1a1a1a; background: transparent; width: 100%;" />
      <div style="display: flex; align-items: center; gap: 6px; background: #f5f5f5; padding: 8px 12px; border-radius: 8px; font-size: 14px; font-weight: 600; color: #1e5a3f; flex-shrink: 0;">
        VES
      </div>
    </div>
  </div>

  <!-- Error messages -->
  <div *ngIf="minError" class="error-shake"
    style="display: flex; align-items: center; gap: 8px; background: #ffebee; border: 2px solid #ef5350; border-radius: 12px; padding: 12px 16px; margin-bottom: 16px;">
    <span style="font-size: 18px;">&#9888;&#65039;</span>
    <span style="font-size: 14px; color: #c62828; font-weight: 500;">
      El monto minimo para enviar es de <strong>{{ minValue | currency }}</strong> CLP
    </span>
  </div>

  <div *ngIf="maxError" class="error-shake"
    style="display: flex; align-items: center; gap: 8px; background: #ffebee; border: 2px solid #ef5350; border-radius: 12px; padding: 12px 16px; margin-bottom: 16px;">
    <span style="font-size: 18px;">&#9888;&#65039;</span>
    <span style="font-size: 14px; color: #c62828; font-weight: 500;">
      El monto maximo para enviar es de <strong>{{ _limitSell | currency }}</strong> CLP
    </span>
  </div>

  <!-- Buttons -->
  <div style="display: flex; flex-direction: column; gap: 12px; margin-top: 24px;">
    <button type="button"
      [disabled]="clpCurrency === 0 || vesCurrency === 0 || maxError || minError"
      (click)="emitChangeStep()"
      [style.background]="!(clpCurrency === 0 || vesCurrency === 0 || maxError || minError) ? '#1C593D' : '#d0d0d0'"
      [style.cursor]="!(clpCurrency === 0 || vesCurrency === 0 || maxError || minError) ? 'pointer' : 'not-allowed'"
      [style.opacity]="!(clpCurrency === 0 || vesCurrency === 0 || maxError || minError) ? '1' : '0.6'"
      style="width: 100%; padding: 16px; color: white; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; transition: background 0.2s;">
      Comprar
    </button>
    <button type="button" (click)="goToBack()"
      style="width: 100%; padding: 14px; background: white; color: #374151; border: 2px solid #d1d5db; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
      Volver
    </button>
  </div>
</div>
